import { createElement } from 'react'

import { Outlet, createBrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import { RedirectRouter } from './pages/RedirectRouter'
import { businessTheme, techTheme, vetTheme } from './styles/theme'
import { InitialContext } from './pages/Initial/initialContext'
import { CandidateLogin } from './pages/Candidatelogin'
import { Container } from './components/Container'
import { getAmbAddr } from 'src/config/ambience'
import { APP_ROUTES, IAppRoute } from './routes'
import { Navbar } from './components/Navbar'
import { Candidate } from './pages/Candidate'
import { WaitingPage } from './pages/Waiting'
import { DeadLine } from './pages/DeadLine'
import { MaintenancePage } from './pages/Maintenance'
import { SecurityCodePage } from './pages/SecurityCode'

const administrativeUrl = getAmbAddr()

const childrenBusiness = APP_ROUTES.map((route: IAppRoute) => ({
  path: route.path,
  element: createElement(route.componentByCourse.business),
}))

const childrenTech = APP_ROUTES.map((route: IAppRoute) => ({
  path: route.path,
  element: createElement(route.componentByCourse.tech),
}))

const childrenVet = APP_ROUTES.map((route: IAppRoute) => ({
  path: route.path,
  element: createElement(route.componentByCourse.vet),
}))

const router = createBrowserRouter([
  {
    path: administrativeUrl,
    children: [
      {
        path: '',
        element: (
          <ThemeProvider theme={businessTheme}>
            <Navbar course="business" />
            <Container>
              <InitialContext course="business" />
            </Container>
          </ThemeProvider>
        ),
        children: childrenBusiness,
      },
      {
        path: 'inscricoes-fechadas',
        element: <DeadLine />,
      },
      {
        path: 'inscricoes-nao-inciadas',
        element: <WaitingPage />,
      },
      {
        path: 'admissao',
        children: [
          {
            path: 'business',
            element: (
              <ThemeProvider theme={businessTheme}>
                <Navbar course="business" />
                <Container>
                  <InitialContext course="business" />
                </Container>
              </ThemeProvider>
            ),
            children: childrenBusiness,
          },
          {
            path: 'ec43c13f-2dfa-48fb-b35b-0662bd7ad0be',
            element: (
              <ThemeProvider theme={businessTheme}>
                <Navbar course="ec43c13f-2dfa-48fb-b35b-0662bd7ad0be" />
                <Container>
                  <InitialContext course="ec43c13f-2dfa-48fb-b35b-0662bd7ad0be" />
                </Container>
              </ThemeProvider>
            ),
            children: childrenBusiness,
          },
          {
            path: 'tech',
            element: (
              <ThemeProvider theme={techTheme}>
                <Navbar course="tech" />
                <Container>
                  <InitialContext course="tech" />
                </Container>
              </ThemeProvider>
            ),
            children: childrenTech,
          },
          {
            path: 'vet-lins',
            element: (
              <ThemeProvider theme={vetTheme}>
                <Navbar course="vet-lins" />
                <Container>
                  <InitialContext course="vet-lins" />
                </Container>
              </ThemeProvider>
            ),
            children: childrenVet,
          },
          {
            path: 'vet-amparo',
            element: (
              <ThemeProvider theme={vetTheme}>
                <Navbar course="vet-amparo" />
                <Container>
                  <InitialContext course="vet-amparo" />
                </Container>
              </ThemeProvider>
            ),
            children: childrenVet,
          },
          {
            path: 'vet',
            element: (
              <RedirectRouter url="http://institutojef.org.br/escolas/vet" />
            ),
            children: childrenVet,
          },
        ],
      },
      {
        path: 'manutencao',
        element: (
          <>
            <Navbar />
            <MaintenancePage />
          </>
        ),
        children: childrenTech,
      },
      {
        path: 'candidato',
        element: (
          <>
            <Navbar />
            <Container>
              <Outlet />
            </Container>
          </>
        ),
        children: [
          {
            path: '',
            element: <Candidate />,
          },
          {
            path: 'login',
            element: <CandidateLogin />,
          },
          {
            path: 'seguranca',
            element: <SecurityCodePage />,
          },
        ],
      },
    ],
  },
])

export default router
